import { Dispatch, SetStateAction } from 'react';

import { UseMutationResult } from '@tanstack/react-query';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { BOOKING_STATUS } from '../../CreateBooking/constants/DetailedBookingConstants';
import { DownloadBookingFilters } from './downloadFilters';

export const bookingActionsUtils = (
    setIsCreateBookingModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setCurrentBookingStatus: React.Dispatch<
        React.SetStateAction<string | undefined>
    >,
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>,
    setEditBookingId: Dispatch<SetStateAction<string | null>>,
    artEventId: string,
    downloadBookingMutation: UseMutationResult<Blob, ApiError, {
        artEventId: string;
        bookingStatus: string;
    } & DownloadBookingFilters, unknown>,
    bookingStatus: string
) => {
    const handleCreateBookingClick = () => setIsCreateBookingModalOpen(true);

    const handleActiveBookingsClick = (
        event?: React.MouseEvent<HTMLButtonElement>
    ) => {
        event?.preventDefault();
        event?.stopPropagation();
        setCurrentBookingStatus(undefined);
        setCurrentPage(0);
    };

    const handleCancelledBookingsClick = (
        event?: React.MouseEvent<HTMLButtonElement>
    ) => {
        event?.preventDefault();
        event?.stopPropagation();
        setCurrentBookingStatus(BOOKING_STATUS.CANCELLED);
        setCurrentPage(0);
    };

    const handleCloseCreateBookingModal = () => {
        setIsCreateBookingModalOpen(false);
        setEditBookingId(null);
    };

    const handleExportBooking = (filters: DownloadBookingFilters = {}) => {
        // Guard against repeated clicks: skip if a download is already in flight.
        // The button is also disabled via isDownloadDisabled (which includes
        // isPending), but this handler-level check avoids the re-render race where
        // a rapid second click lands before the button re-renders as disabled.
        if (artEventId && !downloadBookingMutation.isPending)
            downloadBookingMutation.mutate({
                artEventId,
                bookingStatus,
                ...filters,
            });
    };

    return {
        handleCreateBookingClick,
        handleActiveBookingsClick,
        handleCancelledBookingsClick,
        handleCloseCreateBookingModal,
        handleExportBooking
    };
};